import { render, staticRenderFns } from "./SharingSetTag.vue?vue&type=template&id=e4ebb018"
import script from "./SharingSetTag.vue?vue&type=script&lang=js"
export * from "./SharingSetTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports